import { Controller, useForm } from "react-hook-form";
import SyIcon from "../../../../shared/components/sy-icon";
import SyDropdown from "../../../../shared/forms/sy-dropdown";

import ObrMultiSelect from "../../../../shared/forms/orb-multiselect";
import OrbButton from "../../../../shared/components/orb-button";
import OrbMultiSelect from "../../../../shared/forms/orb-multiselect";
import OrbAsynMultiSelect from "../../../../shared/forms/orb-asyn-multiselect/orb-asyn-multiselect";
import { useMutation } from "@tanstack/react-query";
import planetService from "../../services/planet-service";
import citizenService from "../../services/citizen-service";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { getAuthDetails } from "../../../../feature/auth-slice";

const InviteCitizenPop = (props: any) => {
  const { onClose } = props;
    const { orbitId, planetId } = useParams();

  const defaultValues = {
    citizen: [],
  };
  const { setValue, getValues, control, handleSubmit,} =
    useForm<any>({
      defaultValues: defaultValues,
    });
const formValue =getValues()

  const { mutate: inviteCitizen } = useMutation({
    mutationFn: citizenService.inviteCitizen,
    onSuccess(data, variables, context) {
        onClose('save')
    },
  });

  const onSubmit = (Formvalue: any) => {
   if(Formvalue.citizen.length){
    Formvalue.citizen = Formvalue.citizen.map((data:any)=>data.usr_id)
    const payload ={
        usr_id : Formvalue.citizen,
        orb_id :orbitId,
        pro_id:planetId,
    }
    inviteCitizen(payload)
   }
    
  };

  return (
    <>
      <div className={`rounded-4  p-3 pop-bg`}>
        <div className="d-flex align-items-center justify-content-between pb-3">
          <h2 className="mohave m-0 title-font">invite citizen</h2>
          <SyIcon
            name="close"
            iconType="symbols"
            iconStyle="outlined"
            iconColor="white"
            className={` pointer`}
            onClick={onClose}
          />
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-2">

            <Controller
              name="citizen"
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
        
                  <OrbAsynMultiSelect
                    // options={topFilms}
                    getoptlabel={(opt: any) => opt.usr_name}
                    placeholder="citizen"
                    value={value || []}
                    handleChange={onChange}
                  />
                );
              }}
            />
     
        </div>

        <div className={` mt-3 d-flex justify-content-end `}>
          <OrbButton
            type={"submit"}
            className={" mohave px-3 "}
            size={""}
            label={"invite"}
          />
        </div>
        </form>
      </div>
    </>
  );
};

export default InviteCitizenPop;
